

























export default {
  name: 'CommunityGroupThumbnail',
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      required: true,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    archived: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style(): object | null {
      if (this.group.thumbnail_photo) {
        const thumbnailUrl = this.group.thumbnail_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      if (this.group.cover_photo) {
        const thumbnailUrl = this.group.cover_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      return {};
    },
  },
};
